import React, { useContext, useEffect, useState } from "react";
import "./Concent_Terms_Conditions.css";
import Common_Title_1 from "../common/common_components/common_title_1/Common_Title_1";
import Pink_Btn from "../common/common_btn/pink_btn/Pink_Btn";
import { AllTermsCondition, GetConcentTerms } from '../../features/admin/footer/Slice';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import parse from "html-react-parser";
import Login_Layout_Modal from "../common/modals/login-signup-modals/Login_Layout_Modal";
import { Context } from "../../utils/context";
const Concent_Terms_Conditions = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch();

  const { signin } = useContext(Context);


  const [modelType, setModelType] = useState("sign_up");
  const [selectLogin, setSelectLogin] = useState(false);

  const cencent_terms = useSelector((state) => state.footer.cencent_terms);

  // console.log("all_terms_conditionall_terms_condition",terms_condition)

  useEffect(() => {
    dispatch(GetConcentTerms());
  }, [dispatch]);

  return (
    <section className="Concent_Terms_Conditions Privacy_Policy">
      <Common_Title_1 subText="Concent & Privacy Policy" />

      {/* <p className=''>{parse(all_terms_condition[0]?.content ||"")}</p> */}
      <p className="terms_condition_p">{parse(cencent_terms?.content || "")}</p>

      <div className="btn_holder">{
        signin ? <Pink_Btn btnText={"Go Home"} onClick={() => {
          navigate("/home")
        }} /> :
          <Pink_Btn btnText={"Sign Up"} onClick={() => {
            setModelType("sign_up");
            setSelectLogin(true);
          }} />
      }
      </div>

      <Login_Layout_Modal
        modalType={modelType}
        show={selectLogin}
        onHide={() => setSelectLogin(false)}
      />
    </section>
  );
};

export default Concent_Terms_Conditions;
